import MaintainerReconciliationListView from "../../components/MaintainerReconciliationListView";

MaintainerReconciliationListScreen.propTypes = {};

function MaintainerReconciliationListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="container-fluid px-4 my-4">
                <MaintainerReconciliationListView />
            </div>
        </div>
    );
}

export default MaintainerReconciliationListScreen;
